import { api, getAdminToken } from "./api";

// True when the admin is logged in on THIS browser — their own previews must not
// count as prospect opens (they contaminated all 497 recorded views before).
export function isOwnDevice() {
  try {
    return !!getAdminToken();
  } catch {
    return false;
  }
}

// Fire-and-forget. Analytics must never break or slow the report.
export function trackEvent(token, event, meta = {}) {
  try {
    const p = api.post(`/report/${encodeURIComponent(token)}/event`, { event, meta, own: isOwnDevice() });
    if (p && typeof p.catch === "function") p.catch(() => {});
  } catch {
    /* ignore */
  }
}
